import { useCallback } from "react"
import { useDispatch } from "react-redux"

export default function useAction<T extends (...args: any[]) => any>(actionCreator: T) {
  const dispatch = useDispatch()

  return useCallback(
    (...args: Parameters<T>): ReturnType<typeof dispatch> => {
      return dispatch(actionCreator(...args))
    },
    [dispatch, actionCreator]
  )
}
